import logo from '../../static/image/logo.png';

/** Anchos máximos: móvil / md / lg; misma imagen. */
export const BrandingLogo = ({ className = '' }) => (
	<div
		className={`mx-auto w-full max-w-[250px] md:max-w-[300px] lg:max-w-[300px] transform transition-transform duration-300 hover:scale-105 ${className}`.trim()}
	>
		<img
			src={logo}
			alt="CFA"
			className="block w-full h-auto object-contain drop-shadow-lg"
			decoding="async"
		/>
	</div>
);
